module.exports = __webpack_public_path__ + "static/media/star-rating-low-performer.62f1357a.svg";